import React from 'react';

import { Box, Link } from '@mui/material';

export const CreditSideBar = () => {
  
  const renderLink = (title, link) => {
    return (
      <Link href={`${link}`} sx={{color: 'black'}} target="_blank" rel="noreferrer">{`${title}`}</Link>
    );
  };

  const styles = {
    container : {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      fontSize: '.8em', 
      paddingY: '.5em', 
      color: '#212529'
    }
  };

  return (
    <Box sx={styles.container}>
        &nbsp;<span lang="en">by</span>&nbsp;
      {renderLink('Someware', 'https://www.someware.fr')}
    </Box>
  );
};